import { Overview } from '@/v2/v3/Overview'

// ─── TODAY PAGE ───────────────────────────────────────────────────────────
// v3 Overview screen. Brings its own shell (starfield + market tape + bottom
// nav) so it is NOT wrapped in the old AppLayout. The old V1/V2 Today
// composition (HeroSection, panels, PickOfTheWeek, etc.) is retired here;
// those component files still exist for a later orphan-cleanup pass.
export function V2TodayPage() {
  return <Overview />
}
